"use client";

import Image, { StaticImageData } from "next/image";

type Person = {
	name: string;
	surname: string;
};

type ImageCard = {
	src: string | StaticImageData;
	name?: string;
	surname?: string;
	names?: Person[]; // Nuovo campo per array di nomi
};

type ImageCardGridProps = {
	images: ImageCard[];
};

export default function ImageCardGrid({ images }: ImageCardGridProps) {
	return (
		<div className="mx-auto max-w-[1150px] flex flex-wrap justify-center gap-8">
			{images.map((card, index) => {
				// Determina se è un singolo nome o multipli
				const hasMultipleNames = card.names && card.names.length > 0;
				
				return (
					<div
						key={index}
						className="flex flex-col items-center gap-2"
						style={{ width: "350px", height: "450px" }}
					>
						<div
							className={`
								rounded-xl overflow-hidden relative w-full h-full 
								text-(--card-foreground) shadow-sm hover:shadow-md transition
							`}
						>
							<Image
								src={card.src}
								alt={`Card image ${index + 1}`}
								fill
								className="object-cover"
								sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
								loading="lazy"
							/>
						</div>
						
						{hasMultipleNames ? (
							// Multipli nomi
							<div className="text-center min-h-[56px]">
								{card.names!.map((person, i) => (
									<h2 key={i} className="text-3xl font-extrabold">
										<span className="text-(--foreground)">{person.name}</span>
										<span className="text-(--card-foreground)">{person.surname}</span>
									</h2>
								))}
							</div>
						) : (
							// Singolo nome (retrocompatibile)
							<h2 className="text-3xl line-clamp-2 break-words min-h-[56px] font-extrabold">
								<span className="text-(--foreground)">{card.name}</span>
								<span className="text-(--card-foreground)">{card.surname}</span>
							</h2>
						)}
					</div>
				);
			})}
		</div>
	);
}